import { useEffect } from 'react';

/**
 * Injects a <script type="application/ld+json"> into <head> with the given
 * JSON-LD object, and removes it on unmount. The `id` ensures we don't
 * duplicate scripts when the component re-mounts (StrictMode).
 */
export const StructuredData = ({ id, data }) => {
  useEffect(() => {
    if (!id || !data) return undefined;

    let script = document.getElementById(id);
    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }

    try {
      script.textContent = JSON.stringify(data);
    } catch (e) {
      // Defensive: if data isn't serializable, remove the broken tag
      script.remove();
      console.error('StructuredData: failed to serialize JSON-LD', e);
      return undefined;
    }

    return () => {
      const node = document.getElementById(id);
      if (node) node.remove();
    };
  }, [id, data]);

  return null;
};

export default StructuredData;
